"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Text_module_scss_1 = __importDefault(require("./Text.module.scss"));
/**
 * @deprecated Please use the same component from `@kaizen/components`
 */
var Text = function (_a) {
    var tag = _a.tag, children = _a.children, _b = _a.inheritBaseline, inheritBaseline = _b === void 0 ? false : _b, _c = _a.inline, inline = _c === void 0 ? false : _c, _d = _a.style, style = _d === void 0 ? "default-style" : _d;
    return react_1["default"].createElement(tag, {
        className: (0, classnames_1["default"])(Text_module_scss_1["default"][style], inheritBaseline && Text_module_scss_1["default"].inheritBaseline, inline && Text_module_scss_1["default"].inline)
    }, children);
};
Text.displayName = "Text";
exports["default"] = Text;
//# sourceMappingURL=Text.js.map